import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura M.',
    location: 'Córdoba',
    text: 'Mi hijo de 8 años se frustraba mucho con las matemáticas. Con este kit entendí cómo explicarle sin que terminemos peleando. ¡Un alivio total!'
  }, {
    name: 'Martín G.',
    location: 'Buenos Aires',
    text: 'Excelente material. Las estrategias para la concentración nos cambiaron la rutina de tareas. Muy recomendable para padres que trabajamos todo el día.'
  }, {
    name: 'Sofía R.',
    location: 'Rosario',
    text: 'Los cuentos del bonus son hermosos y la guía principal me abrió los ojos sobre cómo aprende mi nena. Vale cada peso.'
  }];
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <div className="text-center mb-12" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-159">
            Lo que dicen otros padres...
          </h2>
          <div className="flex justify-center space-x-1" data-id="element-160">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-8 h-8 text-yellow-400 fill-current" data-id="element-161" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-162">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-lg border border-gray-100 ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-163">
              <div className="flex space-x-1 mb-4" data-id="element-164">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-165" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-lg" data-id="element-166">
                "{testimonial.text}"
              </p>
              <div className="flex items-center" data-id="element-167">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold text-xl mr-3" data-id="element-168">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-169">
                  <p className="font-bold text-gray-900" data-id="element-170">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-171">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}